export class ShareArticle {

    static get popupFeatures() {
        return 'width=600,height=640,menubar=no,toolbar=no,status=no,scrollbars=yes,resizable=yes';
    }

    static init() {
        document.addEventListener('click', function (e) {
            var btn = e.target.closest('.share-btn[data-share]');
            if (!btn) {
                return;
            }
            var section = btn.closest('.share-section');
            if (!section) {
                return;
            }

            e.preventDefault();

            var url = section.getAttribute('data-share-url') || window.location.href;
            var title = section.getAttribute('data-share-title') || document.title;
            var type = btn.getAttribute('data-share');

            ShareArticle.handle(type, url, title);
        });
    }

    /**
     * @param {string} type
     * @param {string} url
     * @param {string} title
     */
    static handle(type, url, title) {
        switch (type) {
            case 'facebook':
                ShareArticle.openPopup(ShareArticle.facebookUrl(url));
                break;
            case 'twitter':
                ShareArticle.openPopup(ShareArticle.twitterUrl(title, url));
                break;
            case 'linkedin':
                ShareArticle.openPopup(ShareArticle.linkedinUrl(title, url));
                break;
            case 'reddit':
                ShareArticle.openPopup(ShareArticle.redditUrl(title, url));
                break;
            case 'truthsocial':
                ShareArticle.openPopup(ShareArticle.truthSocialUrl(title, url));
                break;
            case 'whatsapp':
                ShareArticle.openPopup(ShareArticle.whatsappUrl(title, url));
                break;
            case 'email':
                window.location.href = ShareArticle.mailtoUrl(title, url);
                break;
            case 'copy':
                ShareArticle.copyUrl(url);
                break;
            default:
                break;
        }
    }

    static get facebookAppIdDefault() {
        return '61573904080169';
    }

    /**
     * @return {string}
     */
    static facebookAppId() {
        if (typeof autorady !== 'undefined'
            && autorady.facebook_share_app_id
            && String(autorady.facebook_share_app_id).trim() !== '') {
            return String(autorady.facebook_share_app_id).trim();
        }

        return ShareArticle.facebookAppIdDefault;
    }

    /**
     * @param {string} url
     * @return {string}
     */
    static facebookUrl(url) {
        return 'https://www.facebook.com/share_channel/?type=reshare&link='
            + encodeURIComponent(url)
            + '&app_id=' + encodeURIComponent(ShareArticle.facebookAppId())
            + '&source_surface=external_reshare&display&hashtag';
    }

    /**
     * @param {string} title
     * @param {string} url
     * @return {string}
     */
    static twitterUrl(title, url) {
        var params = new URLSearchParams({
            text: title,
            url: url,
        });

        return 'https://twitter.com/intent/tweet?' + params.toString();
    }

    /**
     * @param {string} title
     * @param {string} url
     * @return {string}
     */
    static linkedinUrl(title, url) {
        var params = new URLSearchParams({
            mini: 'true',
            url: url,
            title: title,
        });

        return 'https://www.linkedin.com/shareArticle?' + params.toString();
    }

    /**
     * @param {string} title
     * @param {string} url
     * @return {string}
     */
    static redditUrl(title, url) {
        var params = new URLSearchParams({
            url: url,
            title: title,
        });

        return 'https://www.reddit.com/submit?' + params.toString();
    }

    /**
     * @param {string} title
     * @param {string} url
     * @return {string}
     */
    static truthSocialUrl(title, url) {
        return 'https://truthsocial.com/share?text=' + encodeURIComponent(title + ' ' + url);
    }

    /**
     * @param {string} title
     * @param {string} url
     * @return {string}
     */
    static whatsappUrl(title, url) {
        return 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url);
    }

    /**
     * Subject = title; body = title, blank line, URL (mailto-safe encoding).
     *
     * @param {string} title
     * @param {string} url
     * @return {string}
     */
    static mailtoUrl(title, url) {
        var body = title + '\n\n' + url;

        return 'mailto:?subject=' + encodeURIComponent(title)
            + '&body=' + encodeURIComponent(body);
    }

    /**
     * @param {string} href
     */
    static openPopup(href) {
        window.open(href, 'vosveteit-share', ShareArticle.popupFeatures);
    }

    /**
     * @param {string} url
     */
    static copyUrl(url) {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url);

            return;
        }

        var ta = document.createElement('textarea');
        ta.value = url;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();

        try {
            document.execCommand('copy');
        } catch (e) {
            // ignore
        }

        document.body.removeChild(ta);
    }
}
